export const locale = {
  lang: 'pt',
  data: {
    'ALERTS':{
      'OK':'OK'
    },
    'SHEDULE': {
      'TITLE1': 'Data de lançamento do registro: ',
      'TITLE2': 'Registrar lembrete: ',
      'TITLE3': 'Fechamento de registro: ',
      'ERR01':'Os lembretes não podem ser inferiores à data de lançamento',
      'ERR02':'Os lembretes não podem ser maiores que a data de encerramento',
      'ERR03':'Os lembretes devem estar nos 21 dias da pesquisa',
      'ERR04':'Você pode ter apenas três lembretes',
      'ERR05':'A data não pode ser menor que a atual',
      'ERR06':'Você já enviou um email hoje',
      'SUC01':'Lembrete registrado',
      'SELECT_DATE': 'Selecione uma data: ',
      'SAVE': 'Salve ',
      'RECORDATORIOS': 'Lembretes',
      'RECORDATORIO': 'Lembrete',
      'ERRORDATE':'A data não pode ser menor que a atual.',
      'SAMEDATE':'Não é permitido escolher a data atual como data de lançamento da pesquisa',

      'LESSDAYS_T':'Tem certeza que deseja continuar?',
      'LESSDAYS_I':'Para que os colaboradores recebam o plano de comunicação completo, é necessário agendar a pesquisa com pelo menos 15 dias de antecedência.',
      'CONFLDATE_T':'Aviso!',
      'CONFLDATE_I':'Se você continuar, não poderá reverter a data de lançamento. ',
      'WARNING_FECHA_UPDATE':'Você não pode selecionar a data de hoje ou antes disso',
      'FECHA_UPDATE_WARNING':'Não se esqueça de alterar a data de encerramento',
      'FECHA_UPDATE':'A data de encerramento foi actualizada correctamente',

      'FECHA': 'Encontro: ',
      'AGREGAR': 'Adicionar',
      'EDITAR': 'Editar',
      'COMPLETAR_PASO': 'Etapa completa',
      'PASO_COMPLETADO': 'Etapa concluída',
      'SUBIRLOGO': 'Para criar sua pesquisa, é necessário fazer o upload do logotipo da sua empresa',
      'ACEPTARREQUERIMIENTOS': 'Para criar sua pesquisa, é necessário aceitar os requisitos técnicos',
      'LOGOSSURVEY': 'Para criar sua pesquisa, é necessário primeiro estabelecer o (s) logotipo (s) necessário (s)',

      'SELECCIONE_FECHA': 'Por favor selecione uma data',
      'DATE_REGISTERED': 'Data de lançamento registrada corretamente',
      'CLOSE_REGISTERED': 'Data de encerramento registrada com sucesso',
      'CLOSE_MSJ1': 'a data de fechamento deve ser maior que a data de lançamento',
      'CLOSE_MSJ2': 'Antes de fechar, você deve registrar a data de lançamento',
      'REMIDEROK': 'Lembrete registrado com sucesso',
      'REMIDERUPDAOK': 'Lembrete atualizado com sucesso',
      'AVIUPDAOK': 'Notificação devidamente atualizada',
      'REMIDER_MSJ1': 'o lembrete deve ser maior que a data de lançamento',
      'REMIDER_MSJ2': 'Antes de registrar um lembrete, você deve registrar a data de lançamento',
      'ESPERA_ENCUESTA': 'Aguarde, isso pode levar alguns minutos',
      'ENCUESTA': 'Encuesta',
      'CREANDO_ENCUESTA': 'Criando pesquisa...',
      'AGREGANDO_USUARIOS': 'Adicionando usuários...',
      'AGREGANDO_SECCION1': 'Adicionando NPS à pesquisa...',
      'AGREGANDO_SECCION2': 'Adicionando REAGENTS à pesquisa...',
      'AGREGANDO_SECCION3': 'Adicionando CONTROL à pesquisa...',
      'AGREGANDO_SECCION4': 'Adicionando DEMOGRAPHICS à pesquisa...',
      'AGREGANDO_SECCION5': 'Adicionando ADICIONAL à pesquisa...',
      'AGREGANDO_SECCION6': 'Adicionando FORALL à pesquisa...',
      'AGREGANDO_SECCION7': 'Adicionando perguntas abertas à pesquisa...',
      'REINTENTAR': 'Repetir',
      'ERROR_ENCUESTA': 'Erro ao criar pesquisa',
      'ERROR_USUARIOS': 'Erro ao adicionar usuários...',
      'ERROR_SECCION1': 'Falha ao adicionar o NPS à pesquisa...',
      'ERROR_SECCION2': 'Erro ao adicionar REAGENTS à pesquisa...',
      'ERROR_SECCION3': 'Falha ao adicionar CONTROL à pesquisa...',
      'ERROR_SECCION4': 'Erro ao adicionar DEMOGRAPHICS à pesquisa...',
      'ERROR_SECCION5': 'Erro ao adicionar ADICIONAL à pesquisa...',
      'ERROR_SECCION6': 'Erro ao adicionar FORALL à pesquisa...',
      'ERROR_SECCION7': 'Erro ao adicionar perguntas abertas à pesquisa...',

      'SUCCESS_ENCUESTA': 'Pesquisa criada com sucesso!',
      'SUCCESS_USUARIOS': 'Usuários adicionados com sucesso!',
      'SUCCESS_SECCION1': 'NPS adicionado com sucesso à pesquisa!',
      'SUCCESS_SECCION2': 'REAGENTES adicionados com sucesso à pesquisa!',
      'SUCCESS_SECCION3': 'PERGUNTA DE CONTROLE adicionada corretamente à pesquisa!',
      'SUCCESS_SECCION4': 'DEMOGRAPHICS adicionados com sucesso à pesquisa!',
      'SUCCESS_SECCION5': 'ADICIONAL adicionado com sucesso à pesquisa!',
      'SUCCESS_SECCION6': '4 TODAS AS PRÁTICAS adicionadas com sucesso à pesquisa!',
      'SUCCESS_SECCION7': 'PERGUNTAS ABERTAS adicionadas corretamente à pesquisa!',
      'BTN_CREARENCUESTA': 'Criar pesquisa',

      'CONTINUE_FINISH': 'Pesquisa criada com sucesso, finalize a etapa',
      'LAUNCH_SURVEY': 'Crie a pesquisa para concluir a etapa',
      'PULSE':{
        //Shedule survey
        'MES1': ' Pulse Check mes 1',
        'MES2': ' Pulse Check mes 2',
        'MES3': ' Pulse Check mes 3',
        'MES4': ' Pulse Check mes 4',
        'MES5': ' Pulse Check mes 5',
        'MES6': ' Pulse Check mes 6',
        'MES7': ' Pulse Check mes 7',
        'MES8': ' Pulse Check mes 8',
        'MES9': ' Pulse Check mes 9',
        'MES10': ' Pulse Check mes 10',
        'MES11': ' Pulse Check mes 11',
        'MES12': ' Pulse Check mes 12',
        'INDICA': 'Selecciona la fecha de pulse check',
        'INDICA_GENERA':'Generar Encuesta',
        'SUBINDICA_GENERA':'De clic para generar encuesta',


      },
    },
    'SHEDULE2_0': {
      'CARDS': {
        'PASO1': {
          'TITULO': 'Pré-requisitos',
          'INFO_PRE': 'Você precisa cobrir esses pré-requisitos antes de criar a pesquisa',
          'INFO_POST': 'Você já atendeu aos pré-requisitos para criar a pesquisa',
          'REQTEC': 'Requerimentos técnicos',
          'REQTEC_TOOLTIP': 'Vá para os requisitos técnicos',
          'LOGO': 'Logotipo da empresa',
          'LOGO_TOOLTIP': 'Clique para carregar o logotipo',
        },
        'PASO2': {
          'TITULO': 'Data de lançamento',
          'TITULO_CIERRE': 'Data de fechamento',
          'INFO_PRE': 'Selecione e registre a data de lançamento da pesquisa',
          'INFO_POST': 'Data selecionada',
          'INFO_POST_CIERRE': 'Data de fechamento atual',
          'PICKDATE': 'Abrir calendário',
          'CHANGE': 'Data de mudança',
          'LIS-PRORRO':'extensões',
        },
        'PASO2_B': {
          'TITULO': 'Seleção de data',
          'INFO_PRE': 'Selecione e cadastre as diferentes datas disponíveis para configurar a pesquisa',
          'PICKDATE': 'Escolha datas',
          'INFO_PROR': 'Extensões foram atribuídas a este produto',
          'PRORROGAS': 'Veja as extensões',
          'TIUTLOLISTA': 'Extensões criadas',
          'NOPROR': 'Você não tem ramais atribuídos'
        },
        'PASO3': {
          'TITULO': 'Lembretes',
          'INFO_PRE': 'Adicione datas de envio de lembretes para responder à pesquisa',
          'INFO_POST': 'Você tem duas opções:',
          'NUEVO': 'Registrar novo lembrete',
          'LISTA': 'Lembretes gravados',
          'LISTA_AVI': 'Comunicação pré-investigação',
          'TITU_AVIS':'anúncios',
          'TIUTLOLISTA': 'Lembretes criados',
          'NORECOS': 'Você não salvou nenhum lembrete',
          'NOAVI': 'Você não salvou nenhum aviso',
          'INFOHORA': 'NOTA: Cada lembrete é exibido no horário local do instituto:',
          'INFOHORAAVISO': 'NOTA: Cada anúncio é exibido na hora local do instituto:',
          'TITULOLISTA': 'Avisos creados',
        },
        'PASO4': {
          'TITULO': 'Mensagens de comunicação',
          'INFO_PRE': 'Revise as mensagens de comunicação a serem enviadas durante o ciclo de vida da pesquisa',
          'VERMENSAJES': 'Veja mensagens de comunicação',
        },
        'PASO5': {
          'TITULO': 'Verificação de pesquisa',
          'TITULO_ALT': 'Verificação da Tabela Mestre',
          'INFO_PRE': 'Revise as seções da pesquisa, bem como o número de perguntas adicionadas em cada seção',
          'VERMENSAJES': 'Veja os dados da seção',
          'FILTRAR': 'Filtre as seções por nome',
          'TABLE':{
            'SECTION': 'Seção',
            'VALUE': 'Valor',
          }
        },
        'PASO6': {
          'TITULO': 'Histórico de geração de pesquisa',
          'INFO_PRE': 'Última data de geração da pesquisa::',
          'INFO_PRE_2': 'História de geração:',
        },
        'PASO7': {
          'TITULO': 'Características da pesquisa',
          'INFO_PRE': 'Antes de configurar os recursos da pesquisa, você precisa primeiro preencher os pré-requisitos',
          'INFO_POST_1': 'Antes de criar a pesquisa é necessário configurar as características da mesma',
          'INFO_POST_2': 'Você já definiu as configurações necessárias para criar a pesquisa',
          'EMPRESA': 'Logotipo da empresa',
          'CERTIFICADO': 'Logotipo do certificado',
          'CARACTERISTICAS': 'Características da pesquisa',
          'PREVIEW': 'Antevisão',
          'CAMBIAR': 'Mudar a imagem',
          'LOGO_EMP_INFO': 'A imagem é exibida em sua resolução salva, 200x200 pixels'
        },
        'MODALGEN': {
          'REGRESAR': 'Volte',
          'HISTORIAL': {
            'BOTON': 'Histórico de geração de pesquisa',
            'TITULO': 'Histórico de geração de pesquisa',
            'CARGANDO': 'Carregando histórico de geração',
            'ULTIMA': 'Data da última geração',
            'ANTERIORES': 'Datas da geração anterior',
            'NOHISTO': 'Não há histórico da geração da pesquisa'
          },
          'CERTIFICADO': {
            'TITULO': 'Pré-visualização do certificado'
          },
          'URL_QR': {
            'BOTON': 'Obter link em código QR',
            'TITULO': 'Link da pesquisa em código QR',
            'SUBTITULO': 'Ao escanear este código QR, você pode acessar diretamente a pesquisa sem ter que inserir o link manualmente',
            'DESCARGA': 'Para baixar o código QR, clique com o botão direito na imagem e depois na opção <b> <em> Salvar imagem como ... </em> </b>',
            'REGENERARQR': 'O URL foi modificado corretamente, se você tiver um código QR do URL anterior, será necessário obter um novo código QR com o link atualizado'
          }
        },
        'STATUS': {
          'PENDING': 'Ainda não está completo',
          'OK': 'pronto',
          'OPT': 'Esta etapa é opcional',
        },
        'FECHAS': {
          'TITULO': 'Seleção de data',
          'FECHA': 'Data selecionada:',
          'NOTYET': 'Ainda não escolhido',
          'INFO': {
            '1': 'Selecione cada uma das datas disponíveis para configurar a pesquisa.',
            '2': 'NOTA: A hora selecionada em cada data é definida para a hora local do instituto:'
          },
          'TABLA': {
            'TIPO': 'Tipo de data',
            'FECHA': 'Data selecionada',
            'ACCIONES': 'Ações'
          },
          'TIPOS': {
            'lanzamiento': 'Data de lançamento',
            'aviso1': 'Pré-lançamento (primeira notificação antes do lançamento da pesquisa)',
            'aviso2': 'Pré-lançamento (segunda notificação antes do lançamento da pesquisa)',
            'cierre': 'Data limite',
            'recor30': 'Pré-lançamento (Aviso 30 dias antes da pesquisa)',
              'registro29': 'Pré-lançamento (Aviso 29 dias antes da pesquisa)',
              'recor15': 'Pré-lançamento (Aviso 15 dias antes da pesquisa)',
              'recor7': 'Pré-lançamento (Aviso 7 dias antes da pesquisa)',
              'result': 'Resultados:',
          },
          'BOTONES': {
            'ELEGIR': 'Escolha a data',
            'CAMBIAR': 'Data de mudança',
            'CANCELAR': 'Cancelar',
            'ACEPTAR': 'Aceitar',
            'ENVIOCIERRE': 'Enviar notificação'
          }
        }
      },
      'CREAR': 'Criar pesquisa',
      'RECREAR': 'Recrie a pesquisa',
      'ENCUESTACREADA': 'Pesquisa criada',
      'ENCUESTAERROR': 'A pesquisa não foi criada corretamente',
      'VERSECCIONES': 'Veja as seções adicionadas',
      'BACK': 'Costas',
      'CERRAR': 'Perto',
      'CREANDO': 'A pesquisa está sendo criada, aguarde até que cada um de seus componentes seja adicionado corretamente',
      'RETRY': 'Repita o processo',
      'SECCIONES': {
        'DETALLES': 'Salvando os últimos detalhes',
        'COMPLETA': 'A pesquisa foi criada com sucesso!',
        'ENCUESTA': {
          'TITULO': 'Pesquisa',
          'PROCESO': 'Criando pesquisa',
          'ERROR': 'Ocorreu um erro ao criar a pesquisa, tente o processo novamente',
        },
        'USUARIOS': {
          'TITULO': 'Comercial',
          'PROCESO': 'Adicionando usuários à pesquisa',
          'ERROR': 'Ocorreu um erro ao adicionar os usuários, tente o processo novamente',
        },
        'NPS': {
          'TITULO': 'NPS',
          'PROCESO': 'Adicionando NPS à pesquisa',
          'ERROR': 'Ocorreu um erro ao adicionar NPS, tente o processo novamente',
        },
        'REACTIVOS': {
          'TITULO': 'Afirmações',
          'PROCESO': 'Adicionando declarações à pesquisa',
          'ERROR': 'Ocorreu um erro ao adicionar as instruções, tente o processo novamente',
        },
        'CONTROL': {
          'TITULO': 'Questão de controle',
          'PROCESO': 'Adicionando pergunta de controle à pesquisa',
          'ERROR': 'Ocorreu um erro ao adicionar a pergunta de controle, tente o processo novamente',
        },
        'DEMOGRAFICOS': {
          'TITULO': 'Demografia',
          'PROCESO': 'Adicionando dados demográficos à pesquisa',
          'ERROR': 'Ocorreu um erro ao adicionar os dados demográficos, tente novamente o processo',
        },
        'ABIERTAS': {
          'TITULO': 'Perguntas abertas',
          'PROCESO': 'Adicionando perguntas abertas à pesquisa',
          'ERROR': 'Ocorreu um erro ao adicionar perguntas abertas, tente o processo novamente',
        },
        'FORALL': {
          'TITULO': 'Para todos',
          'PROCESO': 'Adicionando práticas ForAll à pesquisa',
          'ERROR': 'Ocorreu um erro ao adicionar as práticas ForAll, tente o processo novamente',
        },
        'ADICIONALES': {
          'TITULO': 'Adicional',
          'PROCESO': 'Adicionando perguntas adicionais à pesquisa',
          'ERROR': 'Ocorreu um erro ao adicionar perguntas adicionais, tente o processo novamente',
        },
        'ADICIONALES-FOCUS': {
          'TITULO': 'Personalizado',
          'PROCESO': 'Acrescentar perguntas personalizadas ao inquérito',
          'ERROR': 'Ocorreu um erro ao acrescentar as perguntas personalizadas, por favor tente novamente o processo',
        },
      },
      'MODALES': {
        'ENCUESTA': {
          'CREAR_1': 'Quer criar a pesquisa com a configuração atual?',
          'CREAR_2': 'Depois que a pesquisa for criada, você não poderá modificar as mensagens de comunicação',
          'CREAR_3': 'Você quer começar a criação da pesquisa',
          'SINFECHA': 'Para criar a pesquisa é necessário primeiro escolher a data de lançamento da mesma',
          'CREADA_1': 'A pesquisa foi criada com sucesso!',
          'CREADA_2': 'Agora você pode completar esta seção e continuar com a próxima',
          'RECOEXIS': 'Já existe um lembrete registrado para o dia selecionado',
          'RECOBEFORE': 'Você não pode gravar um lembrete sem primeiro escolher a data de lançamento da pesquisa',
          'RECOMAX': 'Você já programou todos os lembretes permitidos, não pode mais registrar novos',
          'LASTRECO_1': 'Aviso:',
          'LASTRECO_2': 'Você programou todos os lembretes permitidos, não será mais possível registrar novos',
          'LISTARECOBEF': 'Você não pode ver a lista de lembretes sem primeiro escolher a data de lançamento da pesquisa',
          'FINAL': 'Agora você pode completar esta seção e continuar com a próxima',
          'SAVELAUNCHDATE': 'Salvando a data de lançamento da pesquisa, aguarde um pouco',
          'SAVEAVISODATE': 'Salvando a data de notificação, por favor, aguarde um pouco',
          'AVISOOK': 'Data de notificação salva com sucesso',
          'CHANGELAUNCH': 'Aviso: Se você alterar a data de lançamento da pesquisa, o resto das datas serão apagadas e você terá que selecioná-las novamente, deseja escolher outra data de lançamento?',
          'CHANGECLOSENOT': 'O status de envio da notificação foi alterado com sucesso',
          'GUARDANDO_LOGO': 'Salvando imagem, espere um momento',
          'CARGA_CERT': 'Para obter a mais alta qualidade no documento final, certifique-se de carregar uma imagem com resolução mínima de 400 x 240 pixels.',
          'BORRA_RECO_1': 'Tem certeza de que deseja excluir o lembrete com a seguinte data?',
          'BORRA_RECO_2': 'O lembrete foi excluído com sucesso',
          'BORRA_AVI_1': 'Você tem certeza de apagar o lembrete com a seguinte data?',
          'BORRA_AVI_2': 'O lembrete foi lembrado com sucesso',
          'UPDA_AVISO': 'Update record recordatório de atualização',
          'UPDA_RECOR': 'Update record recordatório de atualização',
          'DELE_AVISO': 'Apagar data de lembrete',
          'DELE_RECOR': 'Apagar data de lembrete',
          'GUARD_RECOR': 'Data de aviso de poupança',
          'TITL_MOD_QUES_ALEAT':'Para criar o inquérito, é necessário activar a validação de perguntas aleatórias.',
          'TEXT_MOD_QUES_ALEAT_1':'De seguida, siga estes passos:',
          'TEXT_MOD_QUES_ALEAT_2':'1.- Introduzir em editar as características do inquérito.',
          'TEXT_MOD_QUES_ALEAT_3':'2.- Clique em configuração adicional e active a validação de perguntas aleatórias',
        }
      },
      'CORREOS': {
        'VER': 'Ver mensagem',
        'TIPO1': {
            'TITULO': 'Mensagem de pré-lançamento',
            'INFO': 'Estas são as mensagens enviadas dias antes do lançamento da pesquisa',
            'TIPO_1': 'Primeira mensagem de notificação',
            'TIPO_2': 'Segunda mensagem de notificação',
        },
        'TIPO2': {
            'TITULO': 'Mensagem de convite',
            'INFO': 'Esta é a mensagem enviada aos colaboradores no dia do lançamento da pesquisa',
        },
        'TIPO3': {
            'TITULO': 'Mensagem de lembrete',
            'INFO': 'Esta é a mensagem de lembrete enviada nos dias agendados para o efeito.',
        },
        'TIPO4': {
            'TITULO': 'Primeira mensagem de notificação',
            'INFO': ''
        },
        'TIPO5': {
            'TITULO': 'Segunda mensagem de notificação',
            'INFO': ''
        },
        'TIPO6': {
            'TITULO': 'Mensagem de fechamento da pesquisa',
            'INFO': 'Esta é a mensagem enviada aos colaboradores na data de encerramento da pesquisa\nNOTA: só será enviado se estiver ativado'
        },
        'TIPO7': {
          'TITULO': 'Mensagem para colaboradores que não iniciaram sua pesquisa',
          'INFO': 'Esta é a mensagem de lembrete enviada aos colaboradores que ainda não iniciaram a pesquisa'
        },
        'TIPO8': {
          'TITULO': 'Mensagem aos colaboradores que ainda não terminaram',
          'INFO': 'Esta é a mensagem de lembrete enviada aos colaboradores que já começaram sua pesquisa, mas ainda não terminaram'
        },
      },
      'EDITOR': {
        'BOTONES': {
          'INFO': 'Informação importante',
          'SAVE': 'Salvar alterações',
          'EDIT': 'Editar mensagem',
        },
        'PENDING': 'Em processo de validação',
        'MODALINFO': {
          'TITULO': 'Informações importantes sobre o conteúdo do e-mail',
          'PARTE_1': 'Para que o envio do e-mail seja considerado correto, os seguintes rótulos podem ser incluídos no corpo da mensagem (Atenção, os rótulos obrigatórios devem ser incluídos pelo menos uma vez):',
          'PARTE_2': 'A razão para tal se deve ao facto de, ao chegar a data de entrega de cada email, a plataforma realiza automaticamente as seguintes substituições na mensagem:',
          'tag_company': 'O nome da empresa',
          'tag_link': 'O link de acesso à pesquisa',
          'tag_date': 'A data de lançamento da pesquisa',
          'tag_user': 'Senha de acesso à pesquisa',
          'tag_dtb': 'Dias até o lançamento da pesquisa (a partir da data em que a mensagem é enviada)',
          'tag_dtc': 'Dias até o final da pesquisa (a partir da data em que a mensagem é enviada)',
          'tag_end': 'A data de encerramento da pesquisa',
          'tag_userAction': 'User to login',
          'tag_pass': 'Palavra-passe do utilizador',
          'tag_linkAction': 'A ligação de acesso a cultrural Go',
          'PARTE_3': 'As etiquetas podem ser colocadas em qualquer parte do corpo do e-mail. Uma vez que as tags estão presentes no conteúdo, ele pode ser salvo',
          'PARTE_4': 'Nota: é possível que a mensagem precise ser validada por um gerente de projeto, se for o caso, você poderá ver o status de validação do novo e-mail nesta tela. Durante o processo de validação você não poderá fazer uma nova edição do e-mail. Caso contrário, o e-mail será considerado válido imediatamente e você poderá editá-lo novamente, se desejar.',
          'OPC': '(Opcional)',
          'MDT': '(Obrigatório, exceto na mensagem de fechamento)',
        },
        'MODALES': {
          'SINCAMBIOS': 'Você ainda não fez alterações no conteúdo do e-mail',
          'SINTAG': 'Não foi possível salvar o e-mail, a próxima tag não foi encontrada:',
          'GUARDAR_1': 'Você deseja salvar as alterações feitas na mensagem?',
          'GUARDAR_2': 'Lembramos que ele será enviado para validação e você não poderá editá-lo novamente até o final do processo de validação.',
          'SAVEOK_1': 'O conteúdo do e-mail foi salvo corretamente',
          'SAVEOK_2': 'Espere por um gerente de projeto para validar as modificações',
          'ENABLED': 'Um gerente de projeto reativou a edição de e-mail, você pode continuar fazendo modificações',
          'CAMBIOIDIOMA_1': 'Atenção: se você quiser escolher outro idioma, as alterações feitas até agora no idioma atual devem ser salvas primeiro',
          'CAMBIOIDIOMA_2': 'Quer salvar as alterações e escolher outro idioma?',
        }
      },
      'ZONAS': {
        '1': 'Cidade do México',
        '2': 'San Salvador',
        '3': 'Hong Kong',
        '4': 'Cingapura',
        '5': 'Istambul',
        '6': 'Manila',
        '11': 'Brasilia',
        '15': 'Madrid',
        '18': 'Cidade do México',
      },
      'SECCIONES_ESPECIALES': {
        'TITULO': 'Esta pesquisa tem seções especiais',
        'SUBTITULO': 'Abaixo estão os usuários de demonstração de forma agrupada, cada grupo destina-se a testar a pesquisa com cada seção especial separadamente, ou a pesquisa sem seções especiais',
        'ELEGIR': 'Selecione um grupo no menu à esquerda',
        'LISTA': {
          'TITULO': 'seções especiais',
          'SIN_SECCION': 'Pesquisa sem seções especiais'
        }
      },
      'CORREOS_NORM':{
        'TIPO1':{
          'TITULO': 'Mensagem de pré-lançamento',
          'INFO': 'Estas são as mensagens enviadas dias antes do lançamento da pesquisa',
        },
        'TIPO2':{
          'TITULO': 'Mensagem de advertência: 30 dias antes do lançamento do convite' ,
          'INFO': 'Estas são as mensagens enviadas dias antes do lançamento da pesquisa'
        },
        'TIPO3':{
          'TITULO': 'Mensagem de advertência: 29 dias antes do lançamento do convite',
          'INFO': 'Estas são as mensagens enviadas dias antes do lançamento da pesquisa'
        },
        'TIPO4':{
          'TITULO': 'Mensagem de advertência: 15 dias antes do lançamento do convite',
          'INFO': 'Estas são as mensagens enviadas dias antes do lançamento da pesquisa'
        },
        'TIPO5':{
          'TITULO': 'Mensagem de advertência: 7 dias antes do lançamento do convite',
          'INFO': 'Estas são as mensagens enviadas dias antes do lançamento da pesquisa'
        },
        'TIPO6': {
            'TITULO': 'Mensagem de fechamento da pesquisa',
            'INFO': 'Esta é a mensagem enviada aos colaboradores na data de encerramento da pesquisa\nNOTA: só será enviado se estiver ativado'
        },
        'TIPO7':{
          'TITULO': 'Mensagem de lembrete',
          'INFO': 'Esta é a mensagem de lembrete enviada nos dias agendados para o efeito.',
        },
      }

    }
  }
};
